import { useEffect, useState } from "react"
import { FaBirthdayCake, FaBox, FaCalendar, FaCheck, FaDollarSign, FaEdit, FaExternalLinkAlt, FaFlag, FaGlobe, FaIdCardAlt, FaIndustry, FaInfo, FaList, FaMapMarkerAlt, FaMoneyBill, FaPhone, FaPlus, FaRegCalendarAlt, FaSave, FaSuitcase, FaTimes, FaTrash, FaUser, FaUserCog, FaUsers, FaUsersCog } from "react-icons/fa";
import { MdAllInbox, MdEmail, MdMail, MdPassword, MdPerson, MdWorkspaces } from "react-icons/md";
import { BACKEND } from "../config/configEnvs"
import { toast } from "react-toastify"
import axios from "axios"
import { Pagination } from "@mui/material"
import { useSelector } from "react-redux"
import PaginationItem from "../components/ui/components/Pagination"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import CopyToClipBoard from "../utils/CopyToClipBoard"
import IdButton from "../components/ui/components/IdButton"
import Selector from "../components/ui/components/Selector"
import callReasons from "../utils/plainValues/CallReasons"
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import { FormatDateString  } from "../utils/FormatDate"
import { RucVerifier } from "../utils/verifyData/RucVerifier"
import Modal from "../components/ui/Modal"
import FormLoader from "../components/ui/FormLoader";
import InputFormValue from "../components/ui/components/InputFormValue";
import AddIcon from "@mui/icons-material/Add";
import FilterHeadersDialog from "../components/dialogs/FilterHeadersDialog";
import FilterButton from "../components/ui/components/FilterButton";
import GetCountries from "../utils/getData/GetCountries";
import EditButton from "../components/ui/components/EditButton";
import DeleteButton from "../components/ui/components/DeleteButton";
import DinamicBoxButton from "../components/ui/components/DinamicBoxButton";
import DinamicButton from "../components/ui/components/DinamicButton";
import ItemRowProductStakeholder from "../components/stakeholders/ItemRowProductStakeholder";

const SolicitudesPostVenta = () => {

  const headers = [
    { id: 1, show: true, name: "Marca", value: "cliente.nombreComercial", },
    { id: 2, show: true, name: "Fecha solicitud", value: "createdAt", formatter: FormatDateString },
    { id: 3, show: true, name: "Servicios de interés", value: "servicesOfInterest" },
    { id: 4, show: true, name: "Personal que recomendí", value: "workerRelated.name" },
    { id: 5, show: true, name: "Link Google Meet", value: "actions" },
    { id: 6, show: true, name: "Audios adjuntos", value: "audios" },
    { id: 7, show: true, name: "Comentarios", value: "notes" },
    { id: 8, show: true, name: "Cotización creada", value: "quoteCreated.id" },
    { id: 9, show: true, name: "Acciones", value: "actions" },
    { id: 10, show: true, name: "Vendedor asignadoa", value: "quoteCreated.id" },
  ]

  return (
    <div>
      <h1>Solicitudes Post Venta</h1>
    </div>
  )
}

export default SolicitudesPostVenta;